import React from 'react'
import Lottie from 'lottie-react-web'
import loadingData from './loading.json'

const SpinLoading: React.FC<any> = (props) => {
	return <Lottie
		options={{
			animationData: loadingData
		}}
	/>
}

export default SpinLoading